// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"238":"b6e91854","453":"1c13788b"}[chunkId] + ".chunk.js";
};